import React, {useEffect} from 'react';

import Slider from "react-slick";
import discovery from '../../../images/canales/c_discovery.png';
import golden from '../../../images/canales/c_golden.png';
import Button from '../../elements/buttons/Button'

export default function CanalesSlider() {

  var settings = {
    centerMode: true,
    arrow: false,
    centerPadding: '0',
    infinite: true,
    slidesToShow: 2,
    autoplay: true,
    initialSlide: 1,
    speed: 2000,
    autoplaySpeed: 2000,
    swipeToSlide: true,
    vertical: false,
    responsive: [
        {
        breakpoint: 768,
        settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '0',
            slidesToShow: 2,
            autoplay: true,
            infinite: true,
            autoplaySpeed: 2000,
            speed: 2000,
            initialSlide: 1,
            swipeToSlide: true
        }
        }
    ]
  };
  return (
      
        <section className="agregaCanales sectionDisfrutaCanales">
            <h3 className="titles">Disfruta de los canales más <br />exclusivos de la TV</h3>
            <div className="wrap">
                <Slider {...settings}>
                <div>
                    <div className="agregaCanales__canal">
                        <img src={discovery} />
                    </div>
                </div>
                <div>
                    <div className="agregaCanales__canal">
                        <img src={golden} />
                    </div>
                </div>
                </Slider>
                <Button copy="Pruébalo gratis" link="/" className="button-solid-grad-pink button-icon" />
            </div>
    </section>
    
  );
}